document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const atcButton = productForm.querySelector('[type="submit"]');
  const hiddenQueryNote = document.getElementById('hidden-query-note');
  if (!atcButton || !hiddenQueryNote) return;

  const isDisableFeatureEnabled = atcButton.classList.contains('disable--true');
  const defaultText = atcButton.getAttribute('data-add-to-cart-text');
  const fallbackText = atcButton.getAttribute('data-atc-fallback-text');
  const customTypeSelect = document.getElementById('custom-type');
  const customTypeProperty = document.getElementById('custom-type-property');
  const customerNote = document.getElementById('customer-note');
  let sparkPdpElement = null;
  let fallbackMessage = null;

  if (isDisableFeatureEnabled) {
    sparkPdpElement = document.querySelector('spark-pdp');
    if (sparkPdpElement) {
      sparkPdpElement.setAttribute('hidden', '');
      fallbackMessage = document.createElement('div');
      fallbackMessage.textContent = window.Shopify?.translations?.products?.product?.choose_options || 'Choose options';
      fallbackMessage.id = 'spark-pdp-fallback';
      fallbackMessage.className = 'btn btn--secondary';
      fallbackMessage.style.display = 'block';
      sparkPdpElement.parentNode.insertBefore(fallbackMessage, sparkPdpElement);
    }
  }

  const updateElementVisibility = () => {
    if (!sparkPdpElement || !fallbackMessage) return;

    const hasCustomType = customTypeSelect?.value.trim();
    const hasCustomerNote = customerNote?.value.trim();

    if (hasCustomType || hasCustomerNote) {
      sparkPdpElement.removeAttribute('hidden');
      fallbackMessage.style.display = 'none';
    } else {
      sparkPdpElement.setAttribute('hidden', '');
      fallbackMessage.style.display = 'block';
    }
  };

  const updateButtonState = () => {
    if (!isDisableFeatureEnabled) {
      atcButton.removeAttribute('disabled');
      atcButton.textContent = defaultText;
      return;
    }

    const hasCustomerNote = customerNote?.value.trim();
    const hasCustomType = customTypeSelect?.value.trim();

    if (hasCustomerNote || hasCustomType) {
      atcButton.removeAttribute('disabled');
      atcButton.textContent = defaultText;
    } else {
      atcButton.setAttribute('disabled', 'disabled');
      atcButton.textContent = fallbackText;
    }
  };

  const updateHiddenNote = (value) => {
    hiddenQueryNote.value = value?.trim() || '';
  };

  if (customTypeSelect?.value.trim()) {
    customTypeProperty.value = customTypeSelect.value;
    updateHiddenNote(customTypeSelect.value);
  }

  if (customerNote?.value.trim()) {
    updateHiddenNote(customerNote.value);
  }

  updateButtonState();
  if (isDisableFeatureEnabled) updateElementVisibility();

  if (customTypeSelect) {
    customTypeSelect.addEventListener('change', (e) => {
      const value = e.target.value;
      customTypeProperty.value = value;
      updateHiddenNote(value);
      updateButtonState();
      if (isDisableFeatureEnabled) updateElementVisibility();
    });
  }

  if (customerNote) {
    customerNote.addEventListener('input', (e) => {
      updateHiddenNote(e.target.value);
      updateButtonState();
      if (isDisableFeatureEnabled) updateElementVisibility();
    });
  }
});